import { IS_ENABLED_ECOMMERCE_OPTIONS } from "@/common/constants";

export const sidebarItems = [
    // ── Tenant-level (always available without merchant) ──────────────────
    {
        id: "customization",
        name: "Personalización",
        icon: "🎨",
        type: "group",
        scope: "tenant",
        items: [
            {
                name: "Editor de catálogo",
                id: "customization-catalog-editor",
                icon: "🧩",
                permission: "tenant:GetBrandingSettings",
                url: "/app/customization/editor"
            },
            {
                name: "Perfil del negocio",
                id: "customization-header",
                icon: "📝",
                permission: "tenant:GetBrandingSettings",
                url: "/app/customization/header"
            },
            {
                name: "Diseño",
                id: "customization-design",
                icon: "🎨",
                permission: "tenant:GetBrandingSettings",
                url: "/app/customization/design"
            }
        ]
    },
    {
        id: "orders",
        name: "Ventas",
        // portal-sesion-y-candados-optimizacion: candado del grupo si el rol
        // no tiene ningún ítem real y sí este permiso `upgrade:*`.
        upgrade: { permission: "upgrade:Order", feature: "internalOrders" },
        feature: "internalOrders",
        icon: "💳",
        type: "group",
        scope: "order",
        items: [
            {
                name: "Ordenes",
                id: "orders",
                icon: "🔷",
                permission: "order:List",
                url: "/app/orders",
                hide: !IS_ENABLED_ECOMMERCE_OPTIONS
            },
            {
                name: "Historial de ventas",
                id: "orders/history",
                icon: "🔷",
                permission: "order:List",
                url: "/app/orders?deliveryStatus=completed"
            },
            {
                name: "Nueva venta",
                id: "orders/hub",
                icon: "🔷",
                permission: "order:Create",
                url: "/app/orders/hub"
            },
            {
                name: "Nueva cotización",
                id: "orders/new_quote",
                icon: "🔷",
                permission: "order:Create",
                url: "/app/orders/new?isQuote=true"
            },
            {
                name: "Ver cotizaciones",
                id: "orders/quotes",
                icon: "🔷",
                permission: "order:List",
                url: "/app/orders?deliveryStatus=quote"
            },
            {
                name: "Grupos de órdenes",
                id: "orders-groups",
                icon: "🔷",
                permission: "orderGroup:List",
                url: "/app/orders-groups"
            },
            {
                name: "Productos por despachar",
                id: "orders/references",
                icon: "🔷",
                permission: "order:ListReferences",
                url: "/app/orders/references"
            },
            {
                name: "Calendario de entregas",
                id: "orders/schedule",
                icon: "🔷",
                permission: "order:List",
                url: "/app/orders/schedule"
            },
            {
                name: "Ventas por producto",
                id: "orders/products",
                icon: "🔷",
                permission: "order:ListReferences",
                url: "/app/orders/product"
            }
        ]
    },
    {
        id: "products",
        name: "Productos",
        upgrade: { permission: "upgrade:Product", feature: "products" },
        feature: "products",
        icon: "🛍️",
        type: "group",
        scope: "product",
        items: [
            {
                name: "Productos",
                id: "products",
                permission: "product:List",
                icon: "🔷",
                url: "/app/products"
            },
            {
                name: "Nuevo producto",
                id: "products",
                permission: "product:Record",
                icon: "🔷",
                url: "/app/products/new"
            },
            {
                name: "Carga masiva",
                permission: "product:LoadMassive",
                id: "products",
                icon: "🔷",
                url: "/app/products/massive"
            },
            {
                name: "Destacados",
                id: "products",
                permission: "reference:ListHighlight",
                icon: "🔷",
                url: "/app/products/highlight"
            },
            {
                name: "Tablas logística",
                id: "logistic-configurations",
                permission: "logisticConfiguration:List",
                icon: "🔷",
                url: "/app/logistic-configurations"
            },
            {
                name: "Nueva tabla logística",
                id: "products",
                permission: "logisticConfiguration:Create",
                icon: "🔷",
                url: "/app/logistic-configurations/new"
            }
        ]
    },
    {
        id: "blogs",
        name: "Páginas",
        upgrade: { permission: "upgrade:Blog", feature: "blogs" },
        feature: "blogs",
        icon: "📖",
        scope: "blog",
        type: "group",
        items: [
            {
                name: "Páginas",
                id: "blogs",
                icon: "🔷",
                permission: "blog:List",
                url: "/app/blogs"
            },
            {
                name: "Nueva página",
                id: "blogs",
                icon: "🔷",
                permission: "blog:Create",
                url: "/app/blogs/new"
            }
        ]
    },
    {
        id: "customLink",
        name: "Enlaces",
        icon: "🌐",
        permission: "customLink:List",
        type: "item",
        url: "/app/custom-links"
    },
    {
        id: "customers",
        name: "Clientes",
        // Clientes van con las ventas internas (Starter en adelante).
        upgrade: {
            permission: "upgrade:FeatureInternalOrders",
            feature: "internalOrders"
        },
        icon: "👩",
        scope: "customer",
        type: "group",
        items: [
            {
                name: "Clientes",
                id: "customers",
                icon: "🔷",
                permission: "customer:List",
                url: "/app/customers"
            },
            {
                name: "Nuevo cliente",
                id: "customer_new",
                icon: "🔷",
                permission: "customer:Create",
                url: "/app/customers/new"
            }
        ]
    },
    {
        id: "stores",
        name: "Tiendas",
        upgrade: { permission: "upgrade:Store", feature: "stores" },
        feature: "stores",
        icon: "🏪",
        scope: "store",
        type: "group",
        items: [
            {
                name: "Tiendas",
                id: "stores_list",
                icon: "🔷",
                permission: "store:List",
                url: "/app/stores"
            },
            {
                name: "Nueva tienda",
                id: "stores_record",
                icon: "🔷",
                permission: "store:CreateOwn",
                url: "/app/stores/record"
            }
        ]
    },
    {
        id: "lines",
        name: "Categorías",
        feature: "lines",
        icon: "➖",
        type: "group",
        scope: "line",
        items: [
            {
                name: "Categorías",
                id: "lines",
                icon: "🔷",
                permission: "line:List",
                url: "/app/lines"
            },
            {
                name: "Nueva categoría",
                id: "lines",
                icon: "🔷",
                permission: "line:Create",
                url: "/app/lines/new"
            }
        ]
    },
    {
        id: "collections",
        name: "Colecciones",
        feature: "collections",
        icon: "🏷️",
        type: "group",
        scope: "collection",
        items: [
            {
                name: "Colecciones",
                id: "collections",
                permission: "collection:List",
                icon: "🔷",
                url: "/app/collections"
            },
            {
                name: "Nueva colección",
                id: "collections",
                permission: "collection:Create",
                icon: "🔷",
                url: "/app/collections/new"
            },
            {
                name: "Colecciones destacadas",
                id: "collections",
                permission: "collection:ListHighlight",
                icon: "🔷",
                url: "/app/collections/highlight"
            }
        ]
    },
    {
        id: "brands",
        name: "Marcas",
        feature: "brands",
        icon: "🔖",
        type: "group",
        scope: "brand",
        items: [
            {
                name: "Marcas",
                id: "brands",
                icon: "🔷",
                permission: "brand:List",
                url: "/app/brands"
            },
            {
                name: "Nueva marca",
                id: "brands",
                icon: "🔷",
                permission: "brand:Create",
                url: "/app/brands/new"
            },
            {
                name: "Marcas destacadas",
                id: "brands",
                icon: "🔷",
                permission: "brand:ListHighlight",
                url: "/app/brands/highlight"
            }
        ]
    },
    {
        id: "warehouses",
        name: "Bodegas",
        icon: "🏬",
        scope: "warehouse",
        type: "group",
        items: [
            {
                name: "Bodegas",
                id: "warehouses_list",
                icon: "🔷",
                permission: "warehouse:List",
                url: "/app/warehouses"
            },
            {
                name: "Nueva bodega",
                id: "warehouses_new",
                icon: "🔷",
                permission: "warehouse:Create",
                url: "/app/warehouses/new"
            }
        ]
    },
    {
        id: "suppliers",
        name: "Proveedores",
        icon: "🏭",
        scope: "supplier",
        type: "group",
        items: [
            {
                name: "Proveedores",
                id: "suppliers_list",
                icon: "🔷",
                permission: "supplier:List",
                url: "/app/suppliers"
            },
            {
                name: "Nuevo proveedor",
                id: "suppliers_new",
                icon: "🔷",
                permission: "supplier:Create",
                url: "/app/suppliers/new"
            }
        ]
    },
    {
        id: "users",
        name: "Usuarios",
        upgrade: { permission: "upgrade:User", feature: null },
        icon: "👩‍💻",
        scope: "user",
        type: "group",
        items: [
            {
                name: "Nuevo usuario",
                id: "user_new",
                icon: "🔷",
                permission: "user:Create",
                url: "/app/users/new"
            },
            {
                name: "Usuarios",
                id: "user_list",
                icon: "🔷",
                permission: "user:List",
                url: "/app/users"
            },
            {
                name: "Roles",
                id: "role_list",
                icon: "🔷",
                permission: "role:List",
                url: "/app/roles"
            }
        ]
    },
    {
        id: "cart",
        name: "Carros de Compras",
        icon: "🛒",
        type: "group",
        scope: "cart",
        items: [
            {
                name: "Carritos",
                id: "cart",
                icon: "🔷",
                permission: "cart:List",
                url: "/app/carts"
            },
            {
                name: "Nuevo carrito",
                id: "carts",
                icon: "🔷",
                permission: "cart:List",
                url: "/app/carts/new"
            }
        ]
    },
    {
        id: "banners",
        name: "Banners",
        icon: "🧩",
        scope: "banner",
        type: "group",
        items: [
            {
                name: "Banners",
                id: "banners",
                icon: "🔷",
                permission: "banner:List",
                url: "/app/banners"
            },
            {
                name: "Nuevo banner",
                id: "banners",
                icon: "🔷",
                permission: "banner:Create",
                url: "/app/banners/new"
            }
        ]
    },
    {
        id: "files",
        name: "Galería",
        icon: "🖼️",
        scope: "image",
        type: "group",
        items: [
            {
                name: "Imágenes",
                id: "images",
                icon: "🖼️",
                permission: "image:List",
                url: "/app/images"
            },
            {
                name: "Cargar imagen",
                id: "images",
                icon: "📤",
                permission: "image:Create",
                url: "/app/images/new"
            },
            {
                name: "Archivos",
                id: "files",
                icon: "📁",
                permission: "file:List",
                url: "/app/files"
            },
            {
                name: "Nuevo archivo",
                id: "files",
                icon: "📄",
                permission: "file:Create",
                url: "/app/files/new"
            }
        ]
    },

    {
        id: "plan",
        name: "Mi plan",
        icon: "💳",
        permission: "platformSubscription:GetMine",
        type: "item",
        url: "/app/plan"
    },
    {
        id: "settings",
        name: "Configuración",
        icon: "⚙️",
        permission: "tenant:GetProductTypes",
        type: "item",
        url: "/app/settings"
    },
    {
        id: "tenants",
        name: "Tenants",
        icon: "🏢",
        type: "group",
        scope: "tenant",
        items: [
            {
                name: "Lista de tenants",
                id: "tenants",
                icon: "🏢",
                permission: "tenant:List",
                url: "/app/tenants"
            }
        ]
    },
    {
        id: "shared-images",
        name: "Banco de imágenes compartidas",
        icon: "🖼️",
        type: "group",
        scope: "tenant",
        items: [
            {
                name: "Banco de imágenes compartidas",
                id: "shared-images",
                icon: "🖼️",
                permission: "sharedImage:Create",
                url: "/app/shared-images"
            }
        ]
    },

    // ── Merchant context divider ──────────────────────────────────────────
    {
        id: "merchant-divider",
        type: "divider",
        merchantContext: true
    },

    // ── Merchant-level (require active store) ─────────────────────────────
    {
        id: "box",
        name: "Caja",
        icon: "💰",
        permission: "merchant:GetBox",
        type: "item",
        url: "/app/merchant/box",
        merchantContext: true
    },
    {
        id: "orders/new-in-merchant",
        name: "Crear venta",
        icon: "💳",
        permission: "order:CreateInMerchant",
        type: "item",
        url: "/app/orders/new-in-merchant",
        merchantContext: true
    },
    {
        id: "services",
        name: "Servicios",
        icon: "👩‍🏭",
        permission: "merchant:ListServices",
        type: "item",
        url: "/app/merchant/services",
        merchantContext: true
    },
    {
        id: "employees",
        name: "Colaboradores",
        icon: "👩‍💼",
        permission: "merchant:ListOwn",
        type: "item",
        url: "/app/employees",
        merchantContext: true
    },
    {
        id: "inventories",
        name: "Inventarios",
        // sucursales-inventario-multitenant: es el inventario por sucursal
        // (`inventory:*`, Premium); se oculta con el modo de inventario en
        // `none` (`inventoryMode` de la sesión).
        upgrade: {
            permission: "upgrade:Inventory",
            feature: "inventoryByMerchant"
        },
        feature: "inventory",
        icon: "🧮",
        scope: "inventory",
        type: "group",
        merchantContext: true,
        items: [
            {
                name: "Inventario",
                id: "inventories_list",
                icon: "🔷",
                permission: "inventory:Get",
                url: "/app/inventories"
            },
            {
                name: "Nuevo inventario",
                id: "inventories_new",
                icon: "🔷",
                permission: "inventory:Create",
                url: "/app/inventories/new"
            },
            {
                name: "Carga masiva",
                id: "inventories_massive",
                icon: "🔷",
                permission: "inventory:Create",
                url: "/app/inventories/massive"
            },
            {
                name: "Inventario histórico",
                id: "inventories_list",
                icon: "🔷",
                permission: "inventory:ListDate",
                url: "/app/inventories/history"
            }
        ]
    },
    {
        id: "cashOutputs",
        name: "Gastos",
        icon: "💸",
        scope: "merchant",
        type: "group",
        merchantContext: true,
        items: [
            {
                name: "Gastos",
                id: "cash_outputs",
                icon: "💸",
                permission: "cashOutput:List",
                url: "/app/cash-outputs"
            },
            {
                name: "Nuevo gasto",
                id: "cash_outputs",
                icon: "💸",
                permission: "cashOutput:Create",
                url: "/app/cash-outputs/new"
            }
        ]
    },
    {
        id: "supplyLists",
        name: "Listas de compras",
        icon: "📜",
        scope: "merchant",
        type: "group",
        merchantContext: true,
        items: [
            {
                name: "Listas de compras",
                id: "supply-lists",
                icon: "📜",
                permission: "supplyList:List",
                url: "/app/supply-lists"
            },
            {
                name: "Nueva lista de compras",
                id: "supply-lists",
                icon: "📜",
                permission: "supplyList:Create",
                url: "/app/supply-lists/new"
            }
        ]
    }
];

export const sidebarItemsFlat = sidebarItems
    .filter((item) => item.type !== "divider")
    .flatMap((item) => {
        if (item.type === "item") return { ...item, icon: item.icon };
        return item.items.map((item2) => ({
            ...item2,
            icon: item.icon,
            feature: item.feature,
            groupId: item.id
        }));
    });
